export const HIT_TYPE_EVENT = 'event';

export enum AnalyticsEventCategory {
  ACCOUNT_CHANGE_EMAIL = 'change email',
  ACCOUNT_CHANGE_PASSWORD = 'change password',
  ACCOUNT_FORGOT_PASSWORD = 'forgot password',
  ACCOUNT_FORGOT_PASSWORD_BY_EMAIL = 'forgot password by email',
  ACCOUNT_FORGOT_PASSWORD_OTP = 'forgot password otp',
  ACCOUNT_LOG_IN = 'log in',
  ACCOUNT_REGISTER = 'register account',
  ACCOUNT_REGISTER_OTP = 'register account otp',
  ACCOUNT_REGISTER_STORE = 'register store',

  DASHBOARD_HEADER = 'dashboard header',
  DASHBOARD_HEADER_PROFILE = 'dashboard header profile',

  INVOICE_CHECKOUT = 'invoice checkout',
  INVOICE_CREATE = 'create invoice',
  INVOICE_DASHBOARD = 'invoice dashboard',
  INVOICE_DETAIL = 'invoice detail',
  INVOICE_UPDATE = 'update invoice',

  LANDING_AVAILABLE_ON = 'landing available on',
  LANDING_HEADER = 'landing header',
  LANDING_KASPAY_BUSINESS = 'landing kaspay business',

  MENU_BUTTON = 'menu button',

  WALLET_DASHBOARD = 'wallet dashboard',
  WALLET_REDEEM_ACCOUNT_HISTORY = 'wallet redeem account history',
  WALLET_REDEEM_ACCOUNT_CREATE = 'create wallet redeem account',
  WALLET_REDEEM = 'wallet redeem',
  WALLET_REDEEM_OTP = 'wallet redeem otp',
  WALLET_REDEEM_FINISH = 'wallet redeem finish',
  WALLET_TOP_UP = 'top up',
  WALLET_TRANSFER = 'wallet transfer',
  WALLET_TRANSFER_DESTINATION = 'wallet transfer destination',
  WALLET_TRANSFER_FINISH = 'wallet transfer finish',
  WALLET_TRANSFER_OTP = 'wallet transfer otp'
}

export enum AnalyticsEventAction {
  ACCOUNT_CHANGE_EMAIL = 'change email',
  ACCOUNT_CHANGE_PASSWORD = 'change password',
  ACCOUNT_FORGOT_PASSWORD = 'forgot password',
  ACCOUNT_LOG_IN = 'log in',
  ACCOUNT_LOG_OUT = 'log out',
  ACCOUNT_REGISTER = 'register account',
  ACCOUNT_REGISTER_STORE = 'register store',

  INVOICE_CHECKOUT = 'invoice checkout',
  INVOICE_CREATE = 'create invoice',
  INVOICE_DELETE = 'delete invoice',
  INVOICE_UPDATE = 'update invoice',

  LANDING_KASPAY_BUSINESS = 'send business contact',

  OPEN_ACCOUNT_CHANGE_EMAIL_PAGE = 'open change email page',
  OPEN_ACCOUNT_CHANGE_PASSWORD_PAGE = 'open change password page',
  OPEN_ACCOUNT_FORGOT_PASSWORD_PAGE = 'open forgot password page',
  OPEN_ACCOUNT_LOG_IN_PAGE = 'open log in page',
  OPEN_ACCOUNT_REGISTER_PAGE = 'open register account page',
  OPEN_CHATTING_PLATFORM_LINK = 'open chatting platform',
  OPEN_CONTACT_US_PAGE = 'open contact us page',
  OPEN_FAQ_PAGE = 'open faq page',
  OPEN_INVOICE_DASHBOARD_PAGE = 'open invoice dashboard page',
  OPEN_INVOICE_DETAIL_PAGE = 'open invoice detail page',
  OPEN_LANDING_PAGE = 'open landing page',
  OPEN_TERMS_AND_CONDITION_PAGE = 'open terms and condition page',
  OPEN_WALLET_DASHBOARD_PAGE = 'open wallet dashboard page',
  OPEN_WALLET_TOP_UP_PAGE = 'open top up page',
  OPEN_WALLET_REDEEM_ACCOUNT_CREATE_PAGE = 'open create wallet redeem account page',
  OPEN_WALLET_REDEEM_ACCOUNT_HISTORY_PAGE = 'open wallet redeem account history page',
  OPEN_WALLET_TRANSFER_DESTINATION_PAGE = 'open wallet transfer destination page',

  OTP_CONFIRM = 'confirm otp',
  OTP_RESEND = 'resend otp',

  WALLET_TOP_UP = 'top up',
  WALLET_REDEEM_ACCOUNT_CREATE = 'create wallet redeem account',
  WALLET_REDEEM_ACCOUNT_HISTORY_SELECT = 'select wallet redeem account history',
  WALLET_REDEEM = 'wallet redeem',
  WALLET_TRANSFER = 'wallet transfer',
  WALLET_TRANSFER_DESTINATION_CONFIRM = 'confirm transfer destination'
}

export enum AnalyticsEventLabel {
  CHATTING_PLATFORM_KASKUS_CHAT = 'kchat',
  CHATTING_PLATFORM_LINE = 'line',
  CHATTING_PLATFORM_MESSENGER = 'messenger',
  CHATTING_PLATFORM_TELEGRAM = 'telegram',

  INVOICE_FILTER_ALL = 'all',
  INVOICE_FILTER_PENDING = 'pending',
  INVOICE_FILTER_PAID = 'paid'
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/analytics.ts